<template>
  <div class="index">
    <Seacher></Seacher>
    <div class="blacks"></div>
    <div class="content_top">
      <div class="Validator">
        <div class="dimg">
          <img :src="logo" />
        </div>
        <div class="valiaddress">
          <div class="valid_name" style="display: flex">
            <span
              @click="goDetailb(address)"
              style="
                display: inline-block;
                width: 86px;
                color: #fff;
                text-align: left;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                -o-text-overflow: ellipsis;
              "
              >{{ name }}</span
            ><span>Version {{ Version }}</span>
          </div>
          <div class="valid_vasi" @click="goDetailb(address)">
            {{ address }}
          </div>
        </div>
        <div class="copy">
          <img
            src="@/assets/pc/Index/copy.png"
            v-clipboard:copy="address"
            v-clipboard:success="copyClicked"
            v-clipboard:error="onError"
          />
        </div>
      </div>
      <div class="head">Validator detail</div>
      <div class="content_center">
        <div class="block_height">
          <div class="block_tit">Self - Staked :</div>
          <div class="block_con">
            {{ Number(selfStake).toLocaleString() }}TTOS
          </div>
        </div>
        <div class="block_height">
          <div class="block_tit">Delegator Stake :</div>
          <div class="block_con">
            {{ delegated }} TTOS
          </div>
        </div>
        <div class="block_height">
          <div class="block_tit">Delegation Cap :</div>
          <div class="block_con">{{ Number(65000).toLocaleString() }} TTOS</div>
        </div>
        <div class="block_height">
          <div class="block_tit">Filled :</div>
          <div class="block_con">
            {{ Number((delegated / 65000) * 100).toFixed(2) }}%
          </div>
        </div>
        <div class="block_height">
          <div class="block_tit">Delegators :</div>
          <div class="block_con">{{ Number(delegators).toLocaleString() }}</div>
        </div>
        <div class="block_height">
          <div class="block_tit">Workload :</div>
          <div class="block_con">{{ Number(workload).toLocaleString() }}</div>
        </div>
        <div class="block_height">
          <div class="block_tit">Active :</div>
          <div class="block_con">
            <img :src="ImgUrl" />
          </div>
        </div>
        <div class="block_height borernone">
          <div class="block_tit">Online :</div>
          <div class="block_con">{{ online }}</div>
        </div>
      </div>
    </div>
    <div class="Workload">
      <div class="Workload_con">
        <div class="Workload_tit1">
          <div class="Workload_tit1_l">Historical Workload</div>
          <div class="Workload_tit1_r" @click="handleMouseEnter">
            View Calculation Rules
          </div>
        </div>
        <div class="Workload_tit2">
          (Show the workload for the past {{ historyWorkload.length }} days.)
        </div>
        <div class="Workload_box">
          <div
            class="Workload_boxli"
            v-for="(item, index) in historyWorkload"
            :key="index"
          >
            <div
              :class="
                item.workload > item.workloadBenchMark
                  ? 'Workload_boxlil Workload_boxlilg'
                  : 'Workload_boxlil Workload_boxlilr'
              "
            >
              <div
                :class="
                  item.workload > item.workloadBenchMark
                    ? 'progress'
                    : 'progressa'
                "
                :style="{
                  height:
                    (item.workload / item.workloadBenchMark > 1
                      ? 100
                      : (item.workload / item.workloadBenchMark) * 100) + '%',
                }"
              ></div>
              <div class="Workloadtime">
                <div>{{ item.moth }}</div>
                <div>{{ item.day }}</div>
                <!-- {{ item.moth }}<span>{{ item.day }}</span> -->
              </div>
            </div>
            <div class="Workload_boxlir">
              <div class="Workload_boxlirli">
                <div class="Workload_boxlirlitit">Workload :</div>
                <div class="Workload_boxlirlicon">
                  {{ Number(item.workload).toLocaleString() }}
                </div>
              </div>
              <div class="Workload_boxlirli">
                <div class="Workload_boxlirlitit">Workload benchmark :</div>
                <div class="Workload_boxlirlicon">
                  {{ Number(item.workloadBenchMark).toLocaleString() }}
                </div>
              </div>
              <div class="Workload_boxlirli">
                <div class="Workload_boxlirlitit">
                  Bonus Earnings Percentage :
                </div>
                <div class="Workload_boxlirlicon"  v-if="item.workload !==0 && item.workloadBenchMark!==0 "> {{(item.workload / item.workloadBenchMark > 1 ? 100 : ((item.workload / item.workloadBenchMark) * 100).toFixed(2)) + '%'}}</div>
                <div class="Workload_boxlirlicon" v-else>0%</div>
              </div>
            </div>
          </div>

          <div class="tanks" v-show="flag">
            <div class="tanks_box">
              <div class="tanks_tit">
                <div class="tanks_titl">Calculation Rules</div>
                <img src="@/assets/pc/TopValidators/close.png" @click="close" />
              </div>
              <div class="tanks_cons">
                <div class="consli">
                  <span>1.</span>
                  <div>
                    Collect the number of validators and their workloads who
                    have propagated signatures for all blocks on the current
                    day.
                  </div>
                </div>
                <div class="consli">
                  <span>2.</span>
                  <div>
                    Obtain the total number of blocks generated on the day.
                  </div>
                </div>
                <div class="consli">
                  <span>3.</span>
                  <div>
                    Calculate the benchmark workload value: workloadBenchmark =
                    (Total Blocks Generated on the Day * 7) / Number of
                    Validators with Signature Propagation.
                  </div>
                </div>
                <div class="consli">
                  <span>4.</span>
                  <div>
                    If the validator's workload is greater than the benchmark
                    workload value, they are eligible to receive the full
                    rewards for the day. Otherwise, distribute rewards based on
                    the percentage of actual workload compared to the benchmark
                    workload value.
                  </div>
                </div>
                <!-- <div class="consli">
                  <span>5.</span>
                  <div>
                    Addresses with signatures below the calculated average will
                    be ineligible for claiming rewards.
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- translist start -->
    <div class="translist">
      <div class="Block_Top notranslate">
        <span class="notranslate">Delegations </span>
      </div>
      <div class="resume-list">
        <div class="pool_main">
          <div class="tags">
            <div class="indexList">
              <div class="Block_list">
                <ul class="block_list_Top">
                  <li>Address</li>
                  <li>Created On</li>
                  <li class="xila">Amount</li>
                </ul>
              </div>
              <div class="Block_List_center notranslate">
                <ul>
                  <li v-for="(item, index) in transferList" :key="index">
                    <p @click="goDetailb(item.fromAddress)">
                      <span>{{ item.fromAddress }}</span>
                    </p>
                    <p class="grays">{{ item.tradeTime }}</p>
                    <p class="grays">
                      {{ item.amount }}TTOS
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="block">
          <el-pagination
            background
            small
            :current-page.sync="pageNum"
            :page-size="10"
            :pager-count="5"
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- translist end -->
  </div>
</template>

<script>
import Seacher from "@/components/m/Seacher.vue";
import {
  ValidatorDetail,
  GetvalidatorDetail,
} from "../../assets/server/api.js";
import { formatSeconds, getSubStr } from "../../utils/utils.js";
export default {
  components: {
    Seacher,
  },
  watch: {
    // deep: true,
    $route: {
      handler: function (to) {
        // console.log(to);
        this.address = to.query.Address;
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      Address: "",
      pageSize: 1,
      pageNum: 1,
      total: null,
      transferList: [],
      Version: "",
      //开始
      address: "",
      copyContent: "",
      ImgUrl: "",
      selfStake: "",
      delegated: "",
      delegators: "",
      workload: "",
      active: "",
      online: "",
      name: "",
      logo: "",
      img: require("@/assets/pc/TopValidators/tu.png"),
      imgurl: require("@/assets/pc/Index/vers1.png"),

      ImgUrl: "",
      historyWorkload: [],
      flag: false,
    };
  },
  computed: {
    getClientTimezone() {
      var oDate = new Date();
      var nTimezone = -oDate.getTimezoneOffset() / 60;
      return nTimezone.toFixed(2);
    },
  },
  created() {},
  mounted() {
    this.Validators = this.$route.query.Validators;
    this.Address = this.$route.query.Address;
    this.Staked = this.$route.query.Staked;
    this.Delegated = this.$route.query.Delegated;
    this.StakingTotal = this.$route.query.StakingTotal;
    this.Active = this.$route.query.Active;
    this.Online = this.$route.query.Online;
    this.Version = this.$route.query.Version;
    this.getValidatorDetail();
  },
  destroyed() {},
  methods: {
    handleMouseEnter() {
      this.flag = true;
    },
    close() {
      this.flag = false;
    },
    copyClicked(e) {
      this.$message.success({
        type: "info",
        message: "Content copied to clipboard!",
        center: true,
        duration: "500",
      });
    },
    onError(e) {
      this.$message.error("Sorry, copy failed！");
    },
    async getValidatorDetail() {
      let formData = new FormData();
      let params = {
        address: this.$route.query.Address,
        pageNum: this.pageNum,
        pageSize: 10,
      };
      let item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      var res = await GetvalidatorDetail(formData);
      // console.log(res);
      this.total = res.result.count;
      this.selfStake = res.result.validatorInfo.selfStake;
      this.delegators = res.result.validatorInfo.delegators;
      this.delegated = res.result.validatorInfo.delegated;
      this.workload = res.result.validatorInfo.workload;
      this.active = res.result.validatorInfo.active;
      this.online = res.result.validatorInfo.online;
      this.Version = res.result.validatorInfo.version;
      this.name = res.result.validatorInfo.name;
      this.logo = res.result.validatorInfo.logo;
      this.address = res.result.validatorInfo.address;
      this.historyWorkload = res.result.validatorInfo.historyWorkload;
      if(this.historyWorkload !==''||this.historyWorkload==null){
        this.historyWorkload = JSON.parse(this.historyWorkload);
        }
     // this.historyWorkload = JSON.parse(this.historyWorkload);
      //  console.log(this.historyWorkload);
      for (var i = 0; i < this.historyWorkload.length; i++) {
        this.historyWorkload[i].moth =
          this.historyWorkload[i].time.split("-")[1];
        this.historyWorkload[i].day =
          this.historyWorkload[i].time.split("-")[2];
        if (this.historyWorkload[i].moth == "01") {
          this.historyWorkload[i].moth = "Jan";
        } else if (this.historyWorkload[i].moth == "02") {
          this.historyWorkload[i].moth = "Feb";
        } else if (this.historyWorkload[i].moth == "03") {
          this.historyWorkload[i].moth = "Mar";
        } else if (this.historyWorkload[i].moth == "04") {
          this.historyWorkload[i].moth = "Apr";
        } else if (this.historyWorkload[i].moth == "05") {
          this.historyWorkload[i].moth = "May";
        } else if (this.historyWorkload[i].moth == "06") {
          this.historyWorkload[i].moth = "Jun";
        } else if (this.historyWorkload[i].moth == "07") {
          this.historyWorkload[i].moth = "Jul";
        } else if (this.historyWorkload[i].moth == "08") {
          this.historyWorkload[i].moth = "Aug";
        } else if (this.historyWorkload[i].moth == "09") {
          this.historyWorkload[i].moth = "Sep";
        } else if (this.historyWorkload[i].moth == "10") {
          this.historyWorkload[i].moth = "Oct";
        } else if (this.historyWorkload[i].moth == "11") {
          this.historyWorkload[i].moth = "Nov";
        } else if (this.historyWorkload[i].moth == "12") {
          this.historyWorkload[i].moth = "Dec";
        }
      }
      if (this.name == "") {
        this.name = getSubStr(this.address, 0, 4);
      }
      if (this.logo == "") {
        this.logo = this.imgurl;
        // this.logo="@/assets/pc/BkHash/BkHash1.png"
      }
      if (this.active == 0) {
        this.ImgUrl = require("@/assets/pc/TopValidators/TopValidators5.png");
      } else if (this.active == 1) {
        this.ImgUrl = require("@/assets/pc/TopValidators/TopValidators4.png");
      }
      if (this.online == 1) {
        this.online = "Online";
      } else {
        this.online = "Offline";
        //   this.OnlineIndex = 1;
      }

      this.transferList = res.result.list;
      for (var i = 0; i < this.transferList.length; i++) {
        var calctimea = new Date();
        let strdatea = Math.floor(calctimea.getTime() / 1000);
        let timestampa = Math.floor(
          this.gltimea(this.transferList[i].tradeTime) / 1000
        );
        var s = strdatea - timestampa;
        if (s <= 0) {
          s = 1;
        }
        this.transferList[i].tradeTime = formatSeconds(s);
      }
    },
    handleCurrentChange(currentPage) {
      this.pageNum = currentPage;
      this.getValidatorDetail();
    },
    copyClicked(e) {
      this.$message.success({
        type: "info",
        message: "Content copied to clipboard!",
        center: true,
        duration: "500",
      });
    },
    onError(e) {
      this.$message.error("Sorry, copy failed！");
    },
    goDetailb(query) {
      this.$router.push({
        path: "/m/Address",
        query: { address: query },
      });
    },
    gltimea(i) {
      const toDate = new Date(i);
      var d = toDate;
      var localTime = d.getTime();
      var localOffset = d.getTimezoneOffset() * 60000;
      var utc = localTime + localOffset;
      var offset = this.getClientTimezone;
      var korean = utc + 3600000 * offset;
      var nd = korean;
      return nd;
    },
  },
};
</script>

<style lang="less">
.el-tooltip__popper.is-dark {
  background: rgba(36, 41, 49, 0.8) !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #22252e;
  color: #fff;
  font-size: 24px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 400;
  border: none;
}
.el-pager li {
  margin: 0px 6px !important;
  padding: 0px 6px !important;
}
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev {
  background: none;
  color: #adb0c7;
  width: 10px !important;
}

.el-pagination.is-background .el-pager li {
  padding-left: 6px;
  padding-right: 6px;
  height: 48px;
  margin: 0 10px;
  //background: #3c485c;
  background: none;
  border-radius: 8px;
  opacity: 1;

  font-size: 24px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 48px;

  text-align: center;
}
</style>
<style lang="less" scoped>
.index {
  width: 750px;
  margin: 110px auto 0px auto;
  background: #13161b;
  text-align: center;
  .blacks {
    height: 10px;
  }
  .content_top {
    margin: 10px auto 0px auto;
    width: 702px;
    height: 1367px;
    background: #0b0c0f;
    border-radius: 24px 24px 24px 24px;
    opacity: 1;
    .Validator {
      display: flex;
      height: 174px;
      border-bottom: 1px solid #22252e;
      margin-left: 24px;
      margin-right: 24px;
      .dimg {
        width: 100px;
        height: 100px;
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
        margin-top: 25px;
        // margin-left: 24px;
        img {
          width: 100px;
          height: 100px;
          background: #1c2027;
          border-radius: 16px 16px 16px 16px;
          opacity: 1;
        }
      }
      .valiaddress {
        text-align: left;
        margin-top: 24px;
        margin-left: 24px;
        .valid_name {
          // width: 460px;
          // border: 1px solid red;
          font-size: 30px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          span {
            font-size: 24px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #898b8d;
          }
        }
        .valid_vasi {
          margin-top: 8px;
          width: 406px;
          height: 72px;
          font-size: 26px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          word-wrap: break-word;
        }
      }
      .copy {
        width: 60px;
        height: 60px;
        margin-top: 80px;
        margin-left: 64px;
        img {
          width: 60px;
          height: 60px;
        }
      }
    }
    .content_center {
      border: none;
      .borernone {
        border-bottom: none !important;
      }
      .bkheight {
        height: 140px !important;
      }
      .block_height {
        height: 112px;
        margin-top: 28px;
        border-bottom: 1px solid #22252e;

        .block_tit {
          font-size: 26px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #8a8a8a;
          height: 36px;
          line-height: 36px;
        }
        .block_con {
          font-size: 26px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #8a8a8a;
          height: 36px;
          line-height: 36px;
          margin-top: 12px;
          // margin-bottom: 12px;
          display: flex;
          .block_hasha {
            width: 334px;
            height: 72px;
            font-size: 26px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #8a8a8a;
            line-height: 36px;
            word-wrap: break-word;
            margin-right: 160px;
          }
          .block_hash {
            width: 565px;
            height: 72px;
            font-size: 26px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #8a8a8a;
            line-height: 36px;
            word-wrap: break-word;
          }
          img {
            width: 40px;
            height: 40px;
            margin-left: 10px;
          }
        }
      }
      // div {
      //   height: 88px;
      // }
      // .gh {
      //   width: 85px;
      //   font-size: 28px;
      //   font-family: SF Pro Text-Medium, SF Pro Text;
      //   font-weight: 500;
      //   color: rgba(255, 255, 255, 0.55);
      //   line-height: 30px;
      //   padding-top: 10px;

      //   overflow: visible !important;
      //   margin-top: -10px;

      //   word-wrap: break-word;
      //   display: flex;
      //   flex-wrap: wrap;
      // }
      // .libiao {
      //   display: flex;
      // }
      // .Offline {
      //   font-size: 28px;
      //   font-family: SF Pro Text-Regular, SF Pro Text;
      //   font-weight: 400;
      //   color: #e34d59;
      // }
      // .Online {
      //   font-size: 28px;
      //   font-family: SF Pro Text-Regular, SF Pro Text;
      //   font-weight: 400;
      //   color: #1abb8d;
      // }
      // img {
      //   width: 32px;
      //   height: 32px;
      //   margin-top: 8px;
      // }

      // span {
      // }
    }
  }
  .Workload {
    width: 702px;
    position: relative;
    margin: 0 auto;
    background: #0b0c0f;
    border-radius: 24px 24px 24px 24px;
    opacity: 1;
    margin-top: 26px;
    margin-bottom: 26px;
    .Workload_con {
      text-align: left;
      padding-top: 24px;
      margin-left: 24px;
      .Workload_tit1 {
        display: flex;
        justify-content: space-between;
        .Workload_tit1_l {
          height: 35px;
          font-size: 30px;
          font-family: Roboto-Medium, Roboto;
          font-weight: 500;
          color: #ffffff;
          line-height: 35px;
        }
        .Workload_tit1_r {
          height: 28px;
          font-size: 24px;
          font-family: Roboto-Medium, Roboto;
          font-weight: 500;
          color: #06c083;
          line-height: 28px;
        }
      }
      .Workload_tit2 {
        height: 28px;
        font-size: 24px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.8);
        line-height: 28px;
        margin-top: 10px;
      }
      .Workload_box {
        margin-top: 36px;

        .Workload_boxli {
          border-bottom: 1px solid #22252e;
          margin-top: 30px;
          padding-bottom: 30px;
          display: flex;
          .Workload_boxlilr {
            border: 4px solid rgba(255, 64, 90, 0.65);
          }
          .Workload_boxlilg {
            border: 4px solid rgba(0, 231, 154, 0.55);
          }
          .Workload_boxlil {
            position: relative;
            width: 93px;
            height: 120px;
            background: #000000;
            border-radius: 12px 12px 12px 12px;
            opacity: 1;
            margin-top: 24px;
            .progress {
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
              // border-radius: 2px 2px 10px 10px;
              background-color: rgba(
                0,
                231,
                154,
                0.2
              ); /* 设置进度条背景颜色及透明度 */
              transition: height 0.3s ease; /* 添加过渡效果 */
            }
            .progressa {
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
              // border-radius: 2px 2px 10px 10px;
              background-color: rgba(
                255,
                64,
                90,
                0.2
              ); /* 设置进度条背景颜色及透明度 */
              transition: height 0.3s ease; /* 添加过渡效果 */
            }

            .Workloadtime {
              height: 33px;
              font-size: 28px;
              font-family: Roboto-Regular, Roboto;
              font-weight: 400;
              color: #ffffff;
              line-height: 33px;
              text-align: center;
              margin-top: 24px;
              span {
                margin-left: 20px;
              }
            }
          }

          .Workload_boxlir {
            // display: flex;
            // margin-left: 55px;
            // justify-content: space-between;
            .Workload_boxlirli {
              display: flex;
              margin-top: 16px;
              margin-left: 55px;
              .Workload_boxlirlitit {
                font-family: Roboto, Roboto;
                font-weight: 500;
                font-size: 26px;
                color: #898b8d;
              }
              .Workload_boxlirlicon {
                font-family: Roboto, Roboto;
                font-weight: 400;
                font-size: 26px;
                color: #898b8d;
              }
            }
          }
        }
        .tanks {
          width: 579px;
          position: absolute;
          left: 120px;
          top: 71px;
          height: 621px;
          background: rgba(36, 41, 49, 1);
          z-index: 999;
          border-radius: 16px 16px 16px 16px;
          opacity: 1;
          .tanks_box {
            margin-left: 20px;
            padding-top: 20px;
            margin-right: 20px;
            .tanks_tit {
              display: flex;
              justify-content: space-between;
              .tanks_titl {
                height: 35px;
                font-size: 24px;
                font-family: Roboto-Medium, Roboto;
                font-weight: 500;
                color: #8e9093;
                line-height: 35px;
              }
              img {
                width: 23px;
                height: 23px;
              }
            }
            .tanks_cons {
              margin-top: 16px;

              .consli {
                display: flex;
                font-size: 24px;
                font-family: Roboto-Regular, Roboto;
                font-weight: 400;
                color: #fff;
                line-height: 35px;
                span {
                  color: #8e9093;
                  margin-right: 2px;
                }
              }
            }
          }
        }
      }
    }
  }
  .translist {
    width: 100%;
    overflow: hidden;
    margin-top: 24px;
    background: #13161b;
    .Block_Top {
      text-align: left;
      width: 702px;
      height: 80px;
      line-height: 80px;
      margin: 0 auto;
      background: #0b0c0f;
      border-radius: 24px 24px 0 0;
      span {
        font-size: 30px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        margin-left: 24px;
      }
      b {
        margin-left: 10px;
      }
    }
    //轮播图片开始
    .resume-list {
      width: 702px;
      background: #0b0c0f;
      border-radius: 0 0 24px 24px;
      margin: 0 auto;
      .pool_main {
        width: 100%;
      }
      .tags {
        display: flex;
        overflow: auto;
        white-space: nowrap;
      }
      //隐藏滚动条
      .tags::-webkit-scrollbar {
        display: none;
      }
      // 列表开始
      .indexList {
        width: 100%;
        margin: 0;
        padding: 0;
        background: #0b0c0f;
        .Block_list {
          .block_list_Top {
            display: flex;
            width: 1000px;
            height: 82px;
            line-height: 82px;
            background: #13161b;
            border-radius: 10px 10px 10px 10px;
            opacity: 1;
            li {
              font-size: 28px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #8a8a8a;
              height: 82px;
              line-height: 82px;
              -webkit-background-clip: text;
              // flex: 0 0 14%;
              text-align: left;
            }
            li:nth-child(1) {
              // border: 1px solid red;
              margin-left: 24px;
              width: 600px;
            }
            li:nth-child(2) {
              width: 400px;
            }
            li:nth-child(3) {
              width: 200px;
            }

            // li:nth-child(7) {
            //   width: 200px;
            // }
          }
        }
        .Block_List_center {
          width: 1000px;
          ul {
            //  height: 620px;
            width: 1000px;
            margin: 0;
            padding: 0;
            //padding: 0 19px;
            li {
              display: flex;
              height: 82px;
              border-bottom: 1px solid #22252e;
              line-height: 82px;
              margin-left: 24px;
              // width: 200px;
              p {
                font-size: 26px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #ffffff;
                text-align: left;
                // flex: 0 0 14%;
              }
              .grays {
                color: #8a8a8a;
              }
            }
            li:last-child {
              border-bottom: none;
            }
            p:nth-child(1) {
              width: 400px;
              span {
                display: inline-block;
                text-align: left;
                margin-left: 6px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                -o-text-overflow: ellipsis;
                width: 300px;
              }
              // border: 1px solid red;
            }
            p:nth-child(2) {
              width: 400px;
            }
            p:nth-child(3) {
              width: 200px;
            }

            // p:nth-child(7) {
            //   width: 200px;
            // }
          }
        }
      }
      .block {
        margin-top: 70px;
        padding-bottom: 70px;
        font-size: 28px;
        font-family: "PingFang SC-中黑体, PingFang SC";
        font-weight: normal;
        color: #adb0c7;
        // line-height: 39px;
      }
    }

    //轮播图片结束
  }
  .list {
    text-align: center;
    padding-bottom: 80px;
  }
  .list-data {
    margin: 30px auto 0px auto;
    width: 690px;
    background: #232a35;
    border-radius: 24px 24px 24px 24px;
    opacity: 1;
    border: 2px solid #232a35;

    .block {
      margin-top: 32px;
      padding-bottom: 32px;
      font-size: 28px;
      font-family: "PingFang SC-中黑体, PingFang SC";
      font-weight: normal;
      color: #adb0c7;
      line-height: 39px;
    }
    .head {
      display: -webkit-box;
    }
    .index_contents {
      margin: 0 auto;
      background: #232a35;
      width: 690px;
      img {
        margin: 48px 0;
        width: 476px;
        height: 318px;
      }
    }
  }

  .head {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 690px;
    height: 42px;
    padding-left: 30px;
    text-align: left;
    font-size: 30px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 42px;
    padding-top: 28px;
    margin-bottom: 20px;
    // line-height: 80px;
    span {
      font-size: 26px;
      font-family: "PingFang SC";
      font-weight: normal;
      text-align: left;
      color: #b2b7c2;
      line-height: 100px;
    }
    img {
      width: 20px;
      height: 20px;
      margin: 40px 30px 40px 0px;
    }
  }

  .content_center {
    text-align: left;
    padding: 10px 0px;
    font-size: 28px;
    font-family: SF Pro Text-Medium, SF Pro Text;
    font-weight: 500;
    color: #adb0c7;
    line-height: 36px;
    border-bottom: 1px solid #3c485c;
    padding-bottom: 32px;
    margin: 0px 32px;
    // div {
    //   display: flex;
    //   flex-direction: row;
    //   justify-content: space-between;
    //   height: 44px;
    //   font-size: 28px;
    //   font-family: SF Pro Text-Regular, SF Pro Text;
    //   font-weight: 400;
    //   line-height: 44px;
    //   margin-top: 16px;
    // }
    // span {
    //   padding-bottom: 10px;
    //   text-align: left;
    //   float: right;
    //   height: 44px;
    //   font-size: 28px;
    //   font-family: SF Pro Text-Regular, SF Pro Text;
    //   font-weight: 400;
    //   line-height: 44px;
    //   line-height: 44px;
    //   overflow: hidden;
    //   white-space: nowrap;
    //   text-overflow: ellipsis;
    //   width: 420px;
    // }
    // .green {
    //   color: #00a870;
    // }
    // .black {
    //   height: 44px;
    //   font-size: 28px;
    //   font-family: SF Pro Text-Regular, SF Pro Text;
    //   font-weight: 400;
    //   color: rgba(255, 255, 255, 0.9);
    //   line-height: 44px;
    // }
    // span:nth-child(4) {
    //   color: #2c3852 !important;
    // }
    // span:nth-child(5) {
    //   color: #2c3852 !important;
    // }
    // img {
    //   width: 20px;
    //   height: 20px;
    // }
  }
}
</style>
